@if (messageContent) {
  <p-message severity="warn" icon="pi pi-exclamation-triangle" [closable]="true">
    <p class="font-semibold">{{ messageContent.summary }}</p>
    <p>{{ messageContent.detail }}</p>
  </p-message>
}

@if (uploadedFiles?.length < 4) {
  <form [formGroup]="descriptionForm">
    <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
      <div class="col-span-12 md:col-span-6 lg:col-span-5 pl-2 pr-2">
        <div class="field" [class.p-disabled]="disableComponent">
          <label class="field-required">Document Types:</label>
          <div class="p-field-value">
            <p-multiSelect
              placeholder="Select File Types"
              data-test-id="document-types-multiselect"
              [filter]="false"
              [options]="documentTypesList"
              [disabled]="disableComponent"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="selectedDocumentTypes"
              (onChange)="showUploadButton(selectedDocumentTypes)"
              appendTo="body"
              display="chip"
            ></p-multiSelect>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 lg:col-span-5 pr-6">
        <div class="field" [class.p-disabled]="disableComponent">
          <label>Description:</label>
          <div class="p-field-value">
            <input
              trimInputValue
              placeholder="25 Characters Limit"
              pInputText
              type="text"
              formControlName="fileDescription"
              data-test-id="document-description-input"
              />
              <errors-messages [control]="descriptionForm.get('fileDescription')"></errors-messages>
            </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-12 lg:col-span-2 pl-2 pr-0">
          <div class="field pr-2">
            @if (showButton && !disableComponent && descriptionForm.valid) {
              <document-select-upload
                [multiple]="false"
                [maxFileSize]="maxFileSize"
                [accept]="allowedExtensions.join()"
                (selectFiles)="addFile($event)"
                (errorValidation)="onError($event)"
              ></document-select-upload>
            }
          </div>
        </div>
      </div>
    </form>
  }

  @if (uploadedFiles?.length) {
    <div>
      <selected-document
        [uploadedFiles]="uploadedFiles"
        (deleteItem)="deleteItem($event)"
      ></selected-document>
    </div>
  }

  <p-dialog
    header="Warning"
    appendTo="body"
    [(visible)]="displayDialog"
    [style]="{ width: '300px' }"
    [modal]="true"
    >
    <p-dialog
      header="Warning"
      appendTo="body"
      [(visible)]="displayDialog"
      [style]="{ width: '500px' }"
      [modal]="true"
      >
      @if (fileNameInvalidErrors) {
        The file name contains invalid characters. Please rename the file and try again.
      }
      @if (!fileNameInvalidErrors && fileTypeErrors) {
        Please upload only {{ allowedExtensions.join(', ') }}
      }
      @if (!fileNameInvalidErrors && !fileTypeErrors && fileSizeErrors) {
        Maximum upload size is {{ maxFileSize / (1024 * 1024) }}Mb
      }

      <p-footer>
        <button
          pButton
          type="button"
          icon="pi pi-check"
          label="OK"
          data-test-id="doc-size-warning-confirmation-button"
          (click)="displayDialog = false"
        ></button>
      </p-footer>
    </p-dialog>
